<template>
  <div>
     <v-layout wrap>
    <v-flex md3 xs12>
       <SellerDashboard></SellerDashboard>
    </v-flex>
    <v-flex md9 xs12>
     <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
      <v-row>
       <v-col md="3">
       </v-col>
        <v-col md="6">
          <h2 style="text-align:center;color:black;">
            <b>Add Shipping Charges</b>
          </h2>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-select
              v-model="it"
              prepend-icon="mdi-image-broken"
              :items="items"
              label="Shipping charges"
            ></v-select>

            <div v-if="it === 'All India'">
              <v-text-field
                prepend-icon="mdi-clipboard-text"
                label="Charges"
                type="text"
                class="form-control"
                id="description"
                v-model="charge"
                required
              />
              <v-layout wrap justify-center>
                <v-flex xs12 md12 pt-2 text-center>
                  <v-btn
                    rounded
                    :disabled="false"
                    width="500px"
                    class="text-capitalize hh"
                    dark
                    :ripple="false"
                    color="#26af82"
                    @click="getproduct"
                  >Submit</v-btn>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="it === 'Free'" @click="getFree">
              <v-layout wrap justify-center>
                <v-flex xs12 md12 pt-2 text-center>
                  <v-btn
                    rounded
                    :disabled="false"
                    width="500px"
                    class="text-capitalize hh"
                    dark
                    :ripple="false"
                    color="#26af82"
                    @click="getFree"
                  >Submit</v-btn>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="it === 'Custom'">
              <v-text-field
                prepend-icon="mdi-clipboard-text"
                label="Charges Kerala"
                type="text"
                class="form-control"
                id="description"
                v-model="chargekl"
                required
              />
              <v-text-field
                prepend-icon="mdi-clipboard-text"
                label="Outside Kerala"
                type="text"
                class="form-control"
                id="description"
                v-model="outsidecharge"
                required
              />
              <v-layout wrap justify-center>
                <v-flex xs12 md12 pt-2 text-center>
                  <v-btn
                    rounded
                    :disabled="false"
                    width="500px"
                    class="text-capitalize hh"
                    dark
                    :ripple="false"
                    color="#26af82"
                    @click="getCustom"
                  >Submit</v-btn>
                </v-flex>
              </v-layout>
            </div>

            <br />
          </v-form>
        </v-col>
      </v-row>
    </v-card>
    </v-flex>
     </v-layout>
    <br />
  </div>
</template>
<script>
import axios from "axios";
import SellerDashboard from "@/components/common/SellerDashboard";
export default {
  props: ["id"],
  components: {
    SellerDashboard
  },
  data() {
    return {
      prodata: [],
      charge: "",
      visible: false,
      it: "",

      items: ["All India", "Free", "Custom"]
    };
  },

  mounted: function() {
    // this.getproduct();
    //  this.getFree();
  },

  methods: {
    getproduct() {
      var data = {};
      data["productid"] = this.id;
      data["charge"] = parseFloat(this.charge);
      axios({
        method: "POST",

        url: "/Shipping/Add/AllIndia/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.msg = "added successfully";
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/HomePage/");
                      this.$router.push("/ImageUpload/" + this.id);
                // this.$router.push("/productlist/");
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getFree() {
      var data = {};
      data["productid"] = this.id;

      axios({
        method: "POST",
        url: "/Shipping/Add/Free/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.msg = "added successfully ";
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/ImageUpload/" + this.id);
                // this.$router.push("/productlist/");
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getCustom() {
      var data = {};
      data["productid"] = this.id;
      data["chargekl"] = parseFloat(this.chargekl);
      data["outsidecharge"] = parseFloat(this.outsidecharge);

      axios({
        method: "POST",
        url: "/Shipping/Add/Custom/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.msg = "added successfully ";
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/ImageUpload/" + this.id);
                // this.$router.push("/productlist/");
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    }
  }
};
</script>
<style scoped>
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
</style>